import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import type { MaImage } from '@/lib/zybooks-api';
// import { renameImageInS3 } from '@/lib/zybooks-api';
import { useState } from 'react';

interface ImageEditNameModalProps {
    open: boolean;
    onClose: () => void;
    image: MaImage | null;
    imageName: string;
    onEditSuccess: (oldImage: MaImage, newImage: MaImage) => void;
    onEditFailure: () => void;
}

export const ImageEditNameModal: React.FC<ImageEditNameModalProps> = props => {
    const { open, onClose, image, imageName, onEditSuccess, onEditFailure } = props;
    const [newName, setNewName] = useState(imageName);
    const [isRenaming, setIsRenaming] = useState(false);

    const handleImageRename = async () => {
        if (!image) return;
        setIsRenaming(true);
        try {
            // TODO: Determine if we need to rename images
            // const newImage = await renameImageInS3(image.ma_image_id, newName);
            const newImage = image;
            onEditSuccess(image, newImage);
            onClose();
        } catch {
            onEditFailure();
            onClose();
        } finally {
            setIsRenaming(false);
        }
        onClose();
    };

    return (
        <Dialog
            open={open}
            onOpenChange={onClose}
        >
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Edit Image Name</DialogTitle>
                </DialogHeader>
                <Input
                    type="text"
                    placeholder="Enter new image name"
                    value={newName}
                    onChange={e => setNewName(e.target.value)}
                    className="w-full border p-2"
                    disabled={isRenaming}
                />
                <div className="mt-4 flex justify-end space-x-2">
                    <Button
                        onClick={onClose}
                        disabled={isRenaming}
                    >
                        Cancel
                    </Button>
                    <Button
                        className="text-white"
                        isLoading={isRenaming}
                        onClick={handleImageRename}
                    >
                        Save
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};
